var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['zm-icons-button', 'zm-icons-button--' + _vm.size],attrs:{"type":"button"},on:{"click":_vm.onClick}},[_c('svg',{staticClass:"zm-icons",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.name}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }